<!-- This example requires Tailwind CSS v2.0+ -->
<template>
  <a
    class="link"
    @click.prevent="
      this.fetchHarvestedBatches();
      open = true;
    "
    ><i class="fa-solid fa-eye"></i><span class="space-icon"></span>Ver
    detalles</a
  >
  <TransitionRoot as="template" :show="open">
    <Dialog
      as="div"
      class="fixed z-10 inset-0 overflow-y-auto"
      @close="open = false"
    >
      <div
        class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        "
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay
            class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
          />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span
          class="hidden sm:inline-block sm:align-middle sm:h-screen"
          aria-hidden="true"
          >&#8203;</span
        >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              relative
              inline-block
              align-bottom
              bg-white
              rounded-lg
              px-4
              pt-5
              pb-4
              text-left
              overflow-hidden
              shadow-xl
              transform
              transition-all
              sm:my-8 sm:align-middle sm:max-w-2xl sm:w-full sm:p-6
            "
          >
            <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
              <button
                type="button"
                class="
                  bg-white
                  rounded-md
                  text-gray-400
                  hover:text-gray-500
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-white
                "
                @click="open = false"
              >
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="sm:flex sm:items-start">
              <div class="mt-3 sm:mt-0 sm:ml-4 sm:text-left sm:w-full">
                <DialogTitle
                  class="text-lg leading-6 font-medium text-gray-900"
                >
                  Detalle
                </DialogTitle>

                <div class="py-5">
                  <dl class="grid grid-cols-2 gap-x-4 gap-y-8">
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">Fecha</dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ dateFormatter(harvested_batch.registered_at) }}
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Comprador
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.buyer_name }}
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Cultivo
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.crop.name }}
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Variedad
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.crop_variety.name }}
                        {{ harvested_batch.crop_type.name }}
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Cosecha
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        <ul role="list" class="divide-y divide-gray-200">
                          <li
                            class="
                              pb-3
                              flex
                              items-center
                              justify-between
                              text-base
                            "
                            v-for="harvested_package in harvested_packages"
                            :key="harvested_package.id"
                          >
                            {{ harvested_package.number }}
                            {{ harvested_package.crop_har_package.name }}
                          </li>
                        </ul>
                      </dd>
                    </div>
                    <div class="sm:col-span-1">
                      <dt class="text-base font-medium text-gray-500">
                        Peso neto cosechado
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.total_weight }} kg
                      </dd>
                    </div>

                    <div class="sm:col-span-2">
                      <dt class="text-base font-medium text-gray-500">
                        Descarte
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.discarded_weight }} kg
                      </dd>
                    </div>
                    <div class="sm:col-span-2">
                      <dt class="text-base font-medium text-gray-500">
                        Peso neto procesado
                      </dt>
                      <dd class="mt-1 text-base text-gray-900">
                        {{ harvested_batch.ok_weight }} kg
                      </dd>
                    </div>

                    <div class="sm:col-span-2">
                      <dd class="mt-1 text-base text-gray-900">
                        <div
                          class="
                            inline-block
                            min-w-full
                            py-2
                            align-middle
                          "
                        >
                          <div
                            class="
                              overflow-hidden
                              shadow
                              ring-1 ring-black ring-opacity-5
                              md:rounded-lg
                            "
                          >
                            <table class="table">
                              <thead class="table-header">
                                <tr>
                                  <th scope="col" class="table-header-cell">
                                    Cantidad
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Empaque
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Calibre
                                  </th>
                                  <th scope="col" class="table-header-cell">
                                    Categoría
                                  </th>
                                </tr>
                              </thead>
                              <tbody class="table-body">
                                <tr
                                  class="table-row"
                                  v-for="harvested_exp_package in harvested_exp_packages"
                                  :key="harvested_exp_package.id"
                                >
                                  <td class="table-cell">
                                    {{ harvested_exp_package.number }}
                                  </td>
                                  <td class="table-cell">
                                    {{
                                      harvested_exp_package.crop_exp_package
                                        .name
                                    }}
                                  </td>
                                  <td class="table-cell">
                                    {{ harvested_exp_package.crop_size.name }}
                                  </td>
                                  <td class="table-cell">
                                    {{
                                      harvested_exp_package.crop_category.name
                                    }}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
            <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                type="button"
                class="
                  mt-3
                  w-full
                  inline-flex
                  justify-center
                  rounded-md
                  border border-gray-300
                  shadow-sm
                  px-4
                  py-2
                  bg-white
                  text-base
                  font-medium
                  text-gray-700
                  hover:text-gray-500
                  focus:outline-none
                  focus:ring-2
                  focus:ring-offset-2
                  focus:ring-indigo-500
                  sm:mt-0 sm:w-auto sm:text-sm
                "
                @click="open = false"
              >
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import BasicProductionRequester from "@/views/open_queries/requesters/producer/basic_production.js";

import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "OQProducerBasicProductionDetails",
  components: {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
  },
  props: ["harvested_batch"],
  setup() {
    const open = ref(false);

    return {
      open,
    };
  },
  data() {
    return {
      data_loaded: false,
      harvested_packages: [],
      harvested_exp_packages: [],
    };
  },
  methods: {
    fetchHarvestedBatches: async function () {
      if (!this.data_loaded) {
        let response = await BasicProductionRequester.getProductionDetails(
          this.harvested_batch.id
        );
        this.harvested_packages = response.data.harvested_packages;
        this.harvested_exp_packages = response.data.harvested_exp_packages;
        this.data_loaded = true;
      }
    },
  },
};
</script>